export { default } from "./LazyLoadImage";